import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: () => import('@/views/HomeView.vue'), meta: { title: '学习概览' } },
    { path: '/tutor', name: 'tutor', component: () => import('@/views/TutorView.vue'), meta: { title: 'AI教授' } },
    { path: '/studio', name: 'studio', component: () => import('@/views/LearningStudioView.vue'), meta: { title: '学习工坊' } },
    { path: '/library', name: 'library', component: () => import('@/views/CourseLibraryView.vue'), meta: { title: '课程资源库' } },
    { path: '/graph', name: 'graph', component: () => import('@/views/KnowledgeGraphView.vue'), meta: { title: '知识图谱' } },
    { path: '/grades', name: 'grades', component: () => import('@/views/GradesView.vue'), meta: { title: '成绩分析' } },
    { path: '/teacher', name: 'teacher', component: () => import('@/views/TeacherView.vue'), meta: { title: '教师工作台' } },
    { path: '/teacher/login', name: 'teacher-login', component: () => import('@/views/TeacherLoginView.vue'), meta: { title: '教师登录' } },
    { path: '/teacher/settings', name: 'teacher-settings', component: () => import('@/views/TeacherSettingsView.vue'), meta: { title: '教师设置' } },
    { path: '/settings', name: 'settings', component: () => import('@/views/SettingsView.vue'), meta: { title: '设置' } },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(to => {
  if (to.path.startsWith('/teacher') && to.path !== '/teacher/login' && !sessionStorage.getItem('accessToken')) return '/teacher/login'
})

router.afterEach(to => { document.title = `${String(to.meta.title || '奥博士')} · 奥博士` })
export default router
